export default "__VITE_ASSET__5eab7d6e__"